import { Injectable } from '@angular/core';

import {
  HttpErrorResponse,
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest,
  HttpResponse,
} from '@angular/common/http';

import { Observable, throwError } from 'rxjs';
import { catchError, map } from 'rxjs/operators';

const DEMO_LOGIN_ENDPOINT = '/spotlight/demo/auth/login';
export const SKIP_LOGIN_REDIRECT_HEADER = 'X-Skip-Login-Redirect';

export function shouldRedirectToLogin(
  requestUrl: string,
  responseBody: any,
  skipLoginRedirect = false
): boolean {
  return (
    responseBody?.code === 401 &&
    !skipLoginRedirect &&
    !requestUrl.includes(DEMO_LOGIN_ENDPOINT)
  );
}

@Injectable({
  providedIn: 'root',
})
export class XiaohongInterceptorService implements HttpInterceptor {
  constructor() {}

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    const skipLoginRedirect = req.headers.has(SKIP_LOGIN_REDIRECT_HEADER);
    const request = skipLoginRedirect
      ? req.clone({ headers: req.headers.delete(SKIP_LOGIN_REDIRECT_HEADER) })
      : req;

    // 暂时兼容预发布，后期加上多账户后会删除此代码
    // const request = req.clone({ headers: req.headers.append('account', '5b73ac0c49f2170001b896d5') })
    // return next.handle(request).pipe(
    return next.handle(request).pipe(
      map((event: HttpEvent<any>) => {
        // 正常返回，处理具体返回参数
        if (event instanceof HttpResponse) {
          const result = event.body;
          if (shouldRedirectToLogin(request.url, result, skipLoginRedirect)) {
            if (window.location.href.includes('localhost')) {
              window.location.href = window.location.origin + '/user/login';
            } else {
              const currentUrl = window.location.href;
              if (window.location.href.includes('linkworld.cc')) {
                window.location.href =
                  'http://login.linkworld.cc?redirectUrl=' + currentUrl;
              } else if (!window.location.href.includes('linkworld.cn')) {
                window.location.href = '/login?redirectUrl=' + currentUrl;
              } else {
                window.location.href =
                  'https://login.linkworld.cn?redirectUrl=' + currentUrl;
              }
            }
          }
        }
        return event;
      }),
      catchError((error: HttpErrorResponse) => {
        console.log(error);
        // 检查错误是否由接口引起
        if (error.error instanceof ErrorEvent) {
          // 客户端或网络错误
          console.error('An error occurred:', error.error.message);
        } else {
          // 服务器错误
          console.error(
            `Backend returned code ${error.status}, body was: ${error.error}`
          );
        }
        // 返回一个带有自定义错误消息的observable对象
        return throwError('Something bad happened; please try again later.');
      })
    );
  }
}
